import request from '@/utils/Request'
import { PaginateMeta } from '@/actions/paginate'
import {dateFormat} from "@/helpers/date-format";

export type PosTransaction = {
    store_name: string
    sales_at: string
    total_price: number
    canceled_at: Date
    details: PosTransactionDetail[]
}
export type PosTransactionDetail = {
    item_name: string
    item_number: string
    item_brand_abbreviation: string
    item_part_number: string
    item_size: string
    item_color: string
}
export type ItemAttribute = {
    name: string
    value: string
}

export type ListPosTransactionsRequestParams = {
    from: Date | null
    to: Date | null
    page: number
}

export type PosTransactionsResponse = {
    posTransactions: PosTransaction[]
    meta: PaginateMeta
    accumulatedAmount: number,
    rankAmount: number,
    rankAggregatePeriodFrom: Date,
    rankAggregatePeriodTo: Date,
    firstTransactionAt: Date,
    inclusiveTax: boolean,
  }


export async function listPosTransactions(
    params?: ListPosTransactionsRequestParams,
) {
    return await request.get<PosTransactionsResponse>(`/pos-transactions/`, { from: params?.from != null ? dateFormat(params.from) : null, to: params?.to != null ? dateFormat(params.to) : null, page: params?.page })
}
